import { render, staticRenderFns } from "./covenants.vue?vue&type=template&id=d61907f0&"
import script from "./covenants.vue?vue&type=script&lang=js&"
export * from "./covenants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports